<template>
  <AppInputField class="checkbox">
    <input
      v-bind="$attrs"
      type="checkbox"
      class="app-checkbox"
      :checked="value"
      @input="updateStatus"
    />
    <label v-if="label" :for="$attrs.id">{{ label }}</label>
  </AppInputField>
</template>

<script>
// Components
import AppInputField from 'Ui/AppInputField'

export default {
  name: 'AppCheckbox',
  inheritAttrs: false,

  components: {
    AppInputField,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    updateStatus(event) {
      if (this.$attrs.disabled) {
        event.target.checked = false
        return
      }
      this.$emit('input', event.target.checked)
    },
  },
}
</script>

<style scoped>
.checkbox label {
  cursor: pointer;
}

.app-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 19px;
  height: 19px;
  flex: 0 0 19px;
  border-radius: 2px;
  border: 2px solid var(--c-secondary);
  margin: 1px 11px 0 0;
  text-align: center;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.app-checkbox:disabled {
  background-color: var(--c-secondary-400);
  border-color: var(--c-secondary-500);
  pointer-events: none;
}

.app-checkbox:before {
  position: absolute;
  content: '\f00c';
  font-family: var(--font-awesome);
  font-size: 11px;
  color: var(--c-secondary);
  transform: scale(0);
  backface-visibility: hidden;
  transition: 0.25s all var(--transition-cubic);
}

.app-checkbox:checked:before {
  transform: scale(1);
}
</style>
